import { Injectable ,Output, EventEmitter} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DecimalPipe, DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SecurityService } from '../../../../Core/Security/security.service';
import { ConfigService } from '../../../../Core/Abstract/config.service';
import { LogService } from '../../../../Core/Abstract/log.service';
import { EventsEmitterService } from '../../../../Core/Abstract/emitter.service';
import { Router } from '@angular/router';


@Injectable()
export class UserProfileService extends SecurityService{

    constructor(http:HttpClient,configService:ConfigService,eventsEmitterService: EventsEmitterService, router:Router, logger:LogService, private datePipe:DatePipe) {
        super(http,configService,eventsEmitterService, router ,logger);
    }

    get(bean:any): Observable<any>{
        let serviceUrl = this.baseUrl + 'UserProfileService/data';
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }
    save(langId:any): Observable<any>{
        let options = {"language":langId}
        let serviceUrl = this.baseUrl + 'UserProfileService/update?';
        return this.http.post<any>(serviceUrl,options).pipe(map(response => {return response;}));
    }
}